<template>
  <!-- <div class="text-center"> -->
  <v-dialog v-model="dialog" @click:outside="clickOutside" width="500">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-btn fab dark color="hsla(230, 100%, 50%, 0.8)">
          <v-icon large dark color="white"> mdi-barcode-scan </v-icon>
        </v-btn>
      </div>
    </template>

    <v-form
      ref="entryForm"
      @submit.prevent="searchSjNumber"
      style="position: relative"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Scan Barcode Anda
        </v-card-title>

        <v-card-text class="d-flex justify-center align-center">
          <v-col md="12" style="padding: 0; position: relative; top: 20px">
            <div style="padding: 0 10px">
              <v-col cols="12" style="padding: 0">
                <p style="margin: 0; font-weight: bold">Nomor Surat Jalan</p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-text-field
                  v-model="form.document_no"
                  ref="documentNo"
                  dense
                  style="margin: 0"
                  outlined
                />
              </v-col>
            </div>
          </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            style="position: absolute; top: 10px; right: 10px"
            icon
            small
            color="black"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div style="width: 100%; text-align: center">
            <v-btn color="primary" style="width: 100%" type="submit">
              Cari Surat Jalan
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
  <!-- </div> -->
</template>
<script>
// import { StreamBarcodeReader } from 'vue-barcode-reader'

export default {
  name: 'Barcode-Scanner',
  props: ['page'],
  components: {},
  data() {
    return {
      dialog: false,
      form: {
        document_no: null
      }
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.documentNo) {
              this.$refs.documentNo.focus()
            }
          })
        }, 300)
      }
    }
  },
  methods: {
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    // openDialog() {
    //   // this.dialog = true
    //   // setTimeout(() => {
    //   if (this.dialog) {
    //     this.$nextTick(() => {
    //       this.$refs.documentNo.focus()
    //     })
    //   }
    //   // }, 100)
    // },
    clickOutside() {
      this.form.document_no = ''
      console.log('outside')
    },
    close() {
      this.form.document_no = ''
      setTimeout(() => {
        this.dialog = false
      }, 100)
    },
    searchSjNumber(val) {
      // if (item.includes('VALIDATE_SIGNATURE')) {
      // const id = item.slice(item.indexOf('|') + 1)
      if (decodeURIComponent(this.$route.params.id) === this.form.document_no) {
        console.log('ID STILL SAME')

        this.$emit('loadPage')
        // const routeData = this.$router.resolve(`/detail-persetujuan/${id}`)
        // console.log(routeData)
        // window.open(routeData.href, '_blank')
      } else {
        this.$router.push(
          `/expedition/deliveryorder/detail/${encodeURIComponent(
            this.form.document_no
          )}`
        )
        this.$emit('loadPage')
      }
      // }
      setTimeout(() => {
        this.form.document_no = ''
      }, 500)
    }
  }
}
</script>
<style scoped></style>
